export enum VoiceSearchFeature {
  'lights' = 'lights',
  'action-movies' = 'action-movies',
  'front-door' = 'front-door',
  'children-shows' = 'children-shows',
}

export type VoiceSearchFeatureKey = keyof typeof VoiceSearchFeature;
